module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/extras/about-us/about-us.component.css
// module id = ./src/app/extras/about-us/about-us.component.css
// module chunks = main